import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { UserService } from '../service/user.service';

@Injectable()
export class HeaderInterceptor implements HttpInterceptor {

  constructor(private user: UserService, ) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    let newReq;
    // const access_token = 'c7f51c9e5c7d8afd9f8fdf80a05efcd7';
    // tslint:disable-next-line:variable-name
    // const access_token = this.cacheService.get('access_token') === null ? '' : this.cacheService.get('access_token'); // 'b46db1fc93607c43d0970729d5830159';
    newReq = req.clone({
      url: environment.API_HOST + req.url,
      headers: req.headers
        .set('Content-Type', 'application/json')
        .set('X-UID', this.user.getuid().toString())
    });
    return next.handle(newReq);
  }
}
